import { render, staticRenderFns } from "./CompetenceIcon.vue?vue&type=template&id=cca86f02&scoped=true&"
import script from "./CompetenceIcon.vue?vue&type=script&lang=js&"
export * from "./CompetenceIcon.vue?vue&type=script&lang=js&"
import style0 from "./CompetenceIcon.vue?vue&type=style&index=0&id=cca86f02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca86f02",
  null
  
)

export default component.exports